module.exports = __webpack_public_path__ + "assets/img/box7_img3.c724d20f.png";